import script from "./bureau_teaching_eval.vue?vue&type=script&setup=true&lang=ts"
export * from "./bureau_teaching_eval.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__